export default () => ({
	orderBtnText: '',
	date: null,
	cartItems(){
		// console.log('CI',Object.values(this.$store.cart.items).filter(item => item.count > 0))
		return Object.values(this.$store.cart.items).filter(item => item.count > 0)
	},
	add(id){
		this.$store.cart.items[id].count ++
	},
	remove(id){
		if(this.$store.cart.items[id].count !== 0){
			this.$store.cart.items[id].count --
		}
	},
	total(){
		let total = 0;
		return Object.values(this.$store.cart.items).reduce((sum, item) => sum += (item.price * item.count), 0)
	},
	removeAll(e,msg){
		if(confirm(msg)){
			Object.values(this.$store.cart.items).forEach(item => item.count = 0);
			localStorage.removeItem("cart-details");
			return
		}else{
			e.preventDefault()
		}
	},
	orderValid(){
		const itemsArr = Object.values(this.$store.cart.items)
		let itemsValid = itemsArr.filter(item => item.type === 'boxes').reduce((sum, item) => sum += item.count, 0) >= 5 || itemsArr.filter(item => item.type === 'sets').reduce((sum, item) => sum += item.count, 0) >= 1
		let formValid = this.$store.cart.orderDetails.name && 
		this.$store.cart.orderDetails.address && 
		this.$store.cart.orderDetails.tel && 
		this.$store.cart.orderDetails.payment &&
		this.date

		this.orderBtnText = !itemsValid ? 'errorItems' : 'errorForm'

		if(itemsValid && formValid)
			this.orderBtnText = 'confirm'

		return itemsValid && formValid
	}
})